<template>
    <v-row >
        <v-col cols="12">
            <div class="image-container">
                <img :src="src" />
            </div>
        </v-col>
    </v-row>
</template>

<script>

export default {
    props: [
        // This has been disabled in the initial lint setup - if you are working on this page please determine the correct type for these properties
        //eslint-disable-next-line
        "src"
    ],
    computed: {
        
    },
    methods: {
        
    },
    mounted() {
        
    },
    watch: {
        
    }
};
</script>

<style>
    .image-container img {
        width: 100%;
    }
</style>